__turbopack_context__.v({
  "allCategoryHeading": "home-module__QDzX0G__allCategoryHeading",
  "allCategoryItems": "home-module__QDzX0G__allCategoryItems",
  "background_color": "home-module__QDzX0G__background_color",
  "billerName": "home-module__QDzX0G__billerName",
  "carouselAnnimation": "home-module__QDzX0G__carouselAnnimation",
  "carouselContainer": "home-module__QDzX0G__carouselContainer",
  "carouselImage": "home-module__QDzX0G__carouselImage",
  "carouselItemColor_01": "home-module__QDzX0G__carouselItemColor_01",
  "carouselItemColor_02": "home-module__QDzX0G__carouselItemColor_02",
  "carouselItemColor_03": "home-module__QDzX0G__carouselItemColor_03",
  "carouselItemStyles": "home-module__QDzX0G__carouselItemStyles",
  "carouselItemText": "home-module__QDzX0G__carouselItemText",
  "carouselItemText_01": "home-module__QDzX0G__carouselItemText_01",
  "carouselItemText_02": "home-module__QDzX0G__carouselItemText_02",
  "carouselItemText_03": "home-module__QDzX0G__carouselItemText_03",
  "categoryContainer": "home-module__QDzX0G__categoryContainer",
  "categryHeading": "home-module__QDzX0G__categryHeading",
  "checkAndPayText": "home-module__QDzX0G__checkAndPayText",
  "checkAndPayWrapper": "home-module__QDzX0G__checkAndPayWrapper",
  "checkAndPayWrapperBody": "home-module__QDzX0G__checkAndPayWrapperBody",
  "checkAndPayWrapperHead": "home-module__QDzX0G__checkAndPayWrapperHead",
  "checkPointWrapper": "home-module__QDzX0G__checkPointWrapper",
  "checkPointersDiv": "home-module__QDzX0G__checkPointersDiv",
  "comingSoonCategories": "home-module__QDzX0G__comingSoonCategories",
  "confirmationModalContainer": "home-module__QDzX0G__confirmationModalContainer",
  "confirmationTitle": "home-module__QDzX0G__confirmationTitle",
  "dpdBracket": "home-module__QDzX0G__dpdBracket",
  "drawer_title": "home-module__QDzX0G__drawer_title",
  "drawer_title_meta": "home-module__QDzX0G__drawer_title_meta",
  "home_page_header": "home-module__QDzX0G__home_page_header",
  "howItWorksContainer": "home-module__QDzX0G__howItWorksContainer",
  "loanCategoryContainer": "home-module__QDzX0G__loanCategoryContainer",
  "loanCategoryDiv": "home-module__QDzX0G__loanCategoryDiv",
  "loanCategoryHeaders": "home-module__QDzX0G__loanCategoryHeaders",
  "loanDetailContainer": "home-module__QDzX0G__loanDetailContainer",
  "loanNumber": "home-module__QDzX0G__loanNumber",
  "loginAvatar": "home-module__QDzX0G__loginAvatar",
  "loginBtn": "home-module__QDzX0G__loginBtn",
  "loginBtnShadow": "home-module__QDzX0G__loginBtnShadow",
  "login_drawer": "home-module__QDzX0G__login_drawer",
  "menuItem": "home-module__QDzX0G__menuItem",
  "pointers": "home-module__QDzX0G__pointers",
  "redTag": "home-module__QDzX0G__redTag",
  "right_items": "home-module__QDzX0G__right_items",
  "showLoansContainer": "home-module__QDzX0G__showLoansContainer",
  "showLoansText": "home-module__QDzX0G__showLoansText",
  "staticPagesContainer": "home-module__QDzX0G__staticPagesContainer",
  "staticPagesItem": "home-module__QDzX0G__staticPagesItem",
  "tagLine": "home-module__QDzX0G__tagLine",
  "userInitials": "home-module__QDzX0G__userInitials",
  "verticalLine": "home-module__QDzX0G__verticalLine",
});
